import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "./SubmitButton";
import styles from "./Common.module.scss";
import { CustomTitleBar } from "./ConfirmationDialog";

const DefaultListContent = ({ dataList }) => (
  <div className={styles.list}>
    {dataList.map((item, index) => (
      <div
        key={`${item?.key ?? "item"}-${index}`}
        className={styles.listItem}
      >
        <span className={styles.listKey}>{item?.key}</span>
        <span className={styles.listValue}>{item?.value}</span>
      </div>
    ))}
  </div>
);

const BatchPostingListContent = ({ dataList }) => (
  <div className={`w-100 overflow-auto rounded px-3 py-2 ${styles.batchList}`}>
    {dataList.map((item, index) => (
      <div
        key={`${item?.date ?? "row"}-${index}`}
        className={`d-grid gap-3 py-3 align-items-baseline ${styles.batchListItem}`}
      >
        <span className="fw-semibold text-nowrap">{item?.date}</span>
        <span className="text-nowrap text-truncate">
          {item?.type ? (
            <>
              <span className="fw-semibold">Type:</span> {item.type}
            </>
          ) : null}
        </span>
        <span className="text-nowrap text-truncate">
          {item?.entityLabel && item?.entityValue ? (
            <>
              <span className="fw-semibold">{item.entityLabel}:</span>{" "}
              {item.entityValue}
            </>
          ) : null}
        </span>
        <span className="text-nowrap text-truncate">
          {item?.ref ? (
            <>
              <span className="fw-semibold">Ref:</span> {item.ref}
            </>
          ) : null}
        </span>
      </div>
    ))}
  </div>
);

export default function UserConfirmationDialog({
  message,
  dataList = [],
  confirmMessage,
  onClose,
  onClickYes,
  onClickNo,
  isLoading = false,
  component,
}) {
  const isBatchPosting = component === "batchPosting";

  return (
    <Dialog
      id="user_confirmation_dialog"
      title={<CustomTitleBar />}
      width={isBatchPosting ? 720 : 640}
      onClose={onClose}
    >
      <div className={isBatchPosting ? "px-4 pt-3 pb-2" : "m-3"}>
        {message && (
          <p
            className={`text-primary ${isBatchPosting ? "mb-3" : "align-self-start"
              }`}
          >
            {message}
          </p>
        )}

        {dataList.length > 0 &&
          (isBatchPosting ? (
            <BatchPostingListContent dataList={dataList} />
          ) : (
            <DefaultListContent dataList={dataList} />
          ))}

        {confirmMessage && (
          <p className={isBatchPosting ? "mt-4 mb-3" : "mt-3"}>
            {confirmMessage}
          </p>
        )}
      </div>

      <DialogActionsBar>
        <div className="dialog-footer w-100">
          <Button
            className="common-btn bgBtnSecondary me-2"
            onClick={onClickNo}
            disabled={isLoading}
          >
            No
          </Button>
          <SubmitButton
            onClick={onClickYes}
            isLoading={isLoading}
            className="me-3"
          >
            Yes
          </SubmitButton>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
}
